// extracted by mini-css-extract-plugin
module.exports = {"container":"_3dXktjfWvklncN-GcmdrJ0","groupsList":"WPAWeeKv6EOYf7VUc5mGw"};